import ScrollReveal from '@/components/ScrollReveal';
import PortfolioGrid from '@/components/PortfolioGrid';
import { useLanguage } from '@/lib/i18n';

export default function Portfolio() {
  const { t } = useLanguage();

  return (
    <main id="main-content" className="pt-32 pb-24" data-testid="portfolio-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <ScrollReveal>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#7F00FF]/60 mb-4">Works</p>
          <h1 className="font-syne text-5xl md:text-6xl font-bold tracking-tighter mb-4" data-testid="portfolio-page-title">
            {t('portfolio_title')}
          </h1>
          <p className="text-white/35 text-lg mb-16 max-w-xl" data-testid="portfolio-page-subtitle">
            {t('portfolio_subtitle')}
          </p>
        </ScrollReveal>
        <PortfolioGrid />
      </div>
    </main>
  );
}
